import "./styles.scss";

import { useTranslation } from "react-i18next";
import * as Material from "@mui/material";
import { AddRounded, SettingsRounded, SlowMotionVideoRounded } from "@mui/icons-material";
import { IconArrowsSort } from "@tabler/icons-react";

import { Button } from "@fragments";


export default function ActionsRow({
    handleCreatePlaylist,
    handleReorderPlaylists,
    handleConfigureSession,
    canReorderPlaylists = false
}) {
    const { t } = useTranslation("content");

    return (
        <div className="actions-row mb-6">
            <Button
                color="overlay"
                size="large"
                startIcon={<IconArrowsSort />}
                text={t("section.reorderPlaylists")}
                onClick={handleReorderPlaylists}
                disabled={!canReorderPlaylists}
                tooltip={!canReorderPlaylists ? t("section.reorderPlaylistsDisabled") : undefined}
            />

            <Button
                color="overlay"
                size="large"
                startIcon={<SlowMotionVideoRounded />}
                endIcon={<AddRounded />}
                text={t("section.addPlaylist")}
                onClick={handleCreatePlaylist}
            />

            <Material.Divider
                orientation="vertical"
                flexItem
                className="ml-2 mr-2"
            />

            <Button
                color="overlay"
                size="large"
                endIcon={<SettingsRounded />}
                text={t("section.configureSession")}
                onClick={handleConfigureSession}
            />
        </div>
    );
}

